export const loadScript = async key => {
  return new Promise((resolve, reject) => {
    if (document.getElementById('recaptcha-script')) return resolve();
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${key}`;
    script.id = 'recaptcha-script';
    script.onload = () => {
      const style = document.createElement('style');
      style.textContent = '.grecaptcha-badge { visibility: hidden !important; }';
      document.head.appendChild(style);
      resolve();
    };
    script.onerror = () => reject();
    document.head.appendChild(script);
  });
};

export const execute = async (key, action) => {
  await loadScript(key);
  return new Promise((resolve, reject) => {
    grecaptcha.enterprise.ready(() => {
      grecaptcha.enterprise.execute(key, { action }).then(resolve).catch(reject);
    });
  });
};
